module.exports = __webpack_public_path__ + "static/media/orange_agile.7b5c1c0c.svg";